module.exports = __webpack_public_path__ + "img/prizes-ro.b01c2509.png";